import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DateUtilService } from 'gung-common';
import { AuthService, BackendInterceptor, LocationConfigService } from 'gung-standard';
import { JeevesOpenOrderTableListComponent } from 'gung-standard-jeeves';
import { first } from 'rxjs';

@Component({
    selector: 'ref-ref-open-order-table',
    templateUrl: './ref-open-order-table.component.html',
    styleUrls: ['./ref-open-order-table.component.scss'],
    standalone: false
})
export class RefOpenOrderTableComponent extends JeevesOpenOrderTableListComponent implements OnInit {
  isAdminOrSales: boolean = false;

  ngOnInit() {
    super.ngOnInit();
    this.authService.getRoles().pipe(first()).subscribe(roles => {
      this.isAdminOrSales = roles.includes('ADMIN') || roles.includes('SALES');
    });
  }
}
